export enum QuestTypes {
	MAIN = "MAIN",
	SIDE = "SIDE",
	DAILY = "DAILY",
	EVENT = "EVENT",
	OFFER = "OFFER",
}
